import {Component, ElementRef, EventEmitter, forwardRef, Host, Injector, Input, OnInit, Optional, Output, Renderer2, SkipSelf, ViewChild} from '@angular/core';
import {ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ValueAccessorAbstract} from '@wba-ui-module/components/formfields/commons/value-accessor.abstract';
import {EventUtils} from '@wba/utils/event.utils';
import {ACTIONS_TYPES, EVENT_KATEGORIE, PiwikService} from '@wba/commons/modules/piwik';

@Component({
    selector: 'wba-input-radio',
    templateUrl: './ja-nein-radio.component.html',
    styleUrls: ['./ja-nein-radio.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JaNeinRadioComponent),
            multi: true
        }],
    standalone: false
})
export class JaNeinRadioComponent extends ValueAccessorAbstract implements ControlValueAccessor, OnInit {

  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() errorLabel: string;
  @Input() labelId: string;
  @Input() ariaLabel: string;
  @Input() title: string;
  @Input() hinweis: { target: string; modal: string };
  @Input() required = false;
  @Input() dataAnalyticsName = '';
  @Input() dataAnalyticsNameInfo = '';
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Output() beforeChangeEvent: EventEmitter<{ event: Event, value: boolean }> = new EventEmitter();
  @ViewChild('radioJa', {static: true}) elJa: ElementRef;
  @ViewChild('radioNein', {static: true}) elNein: ElementRef;
  private isEventSent = false;

  constructor(@Optional() @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly eventUtils: EventUtils,
              private readonly elementRef: ElementRef,
              private readonly piwikService: PiwikService,
              private readonly renderer: Renderer2,
              protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      }
    }
  }

  getValue(): string {
    return this.innerValue;
  }

  onBlur() {
    this.eventUtils.focusOut$.next(this.elementRef);
  }

  get hasErrorAndTrackPiwik() {
    const hasControlErrors = this.control?.touched && this.control?.errors;
    if ( hasControlErrors && this.dataAnalyticsName && !this.isEventSent) {
      this.isEventSent = true;
      this.piwikService.trackEventAction(EVENT_KATEGORIE.FEHLER, ACTIONS_TYPES.FORM, this.dataAnalyticsName);
    }
    return hasControlErrors;
  }
}
